/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import BTable from "react-bootstrap/Table";

import {
  useTable,
  usePagination,
  useSortBy,
  useColumnOrder,
  useRowSelect,
  ColumnInstance,
} from "react-table";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import classes from "./Table.module.css";

import { useTranslation } from "react-i18next";

import {
  Row,
  Col,
  Form,
  Button,
  OverlayTrigger,
  Tooltip,
  Spinner,
  Badge
} from "react-bootstrap";
import useSettings from "../../../hooks/useSettings";

import { ReactComponent as LineHeightIcon } from "../../../assets/line-height.svg";
import { ReactComponent as ColumnsIcon } from "../../../assets/columns.svg";

import CustomSortablePopover from "../CustomSortablePopover/CustomSortablePopover";

import usePrevious from "../../../hooks/usePrevious";
import CustomModal from "../CustomModal/CustomModal";
import VarietyDataSheet from "../VarietyDataSheet/VarietyDataSheet";
import {
  searchSpeciesReturnTypes,
  searchVarietyReturnTypes,
  TABLE_SELECT_ROW,
  testDenominationFields,
  testResultsListReturnTypes,
  testDenominationStatus,
  myTestsReturnTypes,
  convertDate,
  isAdvanced,
  checkToday,
  GLOBAL_DATE_FORMAT,
  myAlertsReturnTypes,
  getDenominationStatusText,
  getVarietyStatusTranslatedText,
  searchClassesReturnTypes,
  GLOBAL_DATETIME_FORMAT,
  registersReturnTypes,
  getCountryNamesFromSession,
  contributionsReturnTypes,
  API_URLS,
  downloadUrl,
  jurisprudenceReturnTypes,
  isFullSearchExp
} from "../../../shared/utility";
import SpeciesClassModal from "../../SpeciesClassModal/SpeciesClassModal";
import SpeciesModal from "../../SpeciesModal/SpeciesModal";
import TestDataSheet from "../../TestDataSheet/TestDataSheet";
import AdviceStatusBadge from "../AdviceStatusBadge/AdviceStatusBadge";
import { useAlert } from "../../../shared/AlertService";
import { FONTAWESOME_ICON_NAMES } from "../../../fontawesome";
import RegistersModal from "../../RegistersModal/RegistersModal";
import graphQLClientInstance from "../../../axios-graphql-client";
import JurisprudenceModal, { IActiveJurisprudenceModal } from "../../JurisprudenceModal/JurisprudeneModal";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";

const Table: React.FC<any> = ({
  columns,
  data,
  origin,
  fetchData,
  downloadExcel,
  selectedData,
  totalCount: controlledTotalCount,
  pageCount: controlledPageCount,
  formValues,
  pageSizeOptions,
  hideColumnsButton = false,
  hideDownloadExcelButton = false,
  showPagination = true,
  isSortable = true,
  firstColumnWithoutHeader = false,
  modal = false,
  showTableActionsBottom = false,
  tableRef,
  refreshData,
  activeTab = 0,
  changeTab,
  fakeCount = 0,
  requestBulkAdvice,
  deleteTests,
  deleteAlert,
  archiveTests,
  updateReqAdvice,
  initialSortBy = []
}) => {
  const { t } = useTranslation();

  const renderTooltipOverlayTable = (tooltipTarget: any, tooltipContent: any, key = "") => {
    return (
       <OverlayTrigger
        key={key}
        placement="top"
        delay={{ show: 250, hide: 400 }}
        overlay={(props) => (
          <Tooltip id="button-tooltip" {...props}>
            {tooltipContent}
          </Tooltip>
        )}
      >
        <span className="align-middle inline-block center">
          {tooltipTarget}
        </span>
      </OverlayTrigger>
    );
  };

  interface IRow {
    applicationdate: string;
    applicationnumber: string;
    applicationstatus: string;
    approvaldate: string;
    breedername: string;
    breederreference: string;
    countryid: string;
    countries: Array<string>;
    countryname: string;
    cropsectors: string;
    denomination: string;
    denominationinsertdate: string;
    denominationnature: string;
    denominationstatus: string;
    denominationtype: string;
    futureexpirationdate: string;
    grantdate: string;
    grantnumber: string;
    otherparty: string;
    proposaldate: string;
    pubapplicationdate: string;
    pubgrantdate: string;
    publicationtype: string;
    publicationextraid: number;
    registeredwithother: number;
    registertypename: string;
    renewalregistration: string;
    specieclasscodes: Array<string>;
    specieclasses: Array<string>;
    species: Array<string>;
    specielatinname: string;
    varietyinsertdate: string;
    varietyid: string;
    en?: string[];
    de?: string[];
    es?: string[];
    fr?: string[];
    sub_countries?: string[];
    sub_species?: string[];
    other_bot?: string[];
    princ_bot?: string;
    crop_sector?: string;
    crop_sectors?: string[];
    class_data: any;
    species_id?: string;
    class_type?: number;
    class_name?: string;
    classid?: string;
    publicationname?: string;
    publicationtypeid?: string;
    name?: string;
    websiteurl?: string;
    remarks?: string;
    email?: string;
    addressformatted?: string;
    pub_date?: string;
    pub_info?: string;
    pub_number?: string;
    all_contributions?: Array<any>;
    test_id: number;
    testid: number;
    test_status: number;
    var_id: number;
    species_name_en: Array<string>;
    test_date: number;
    request_advice_id: number;
    comments: string;
    test_archived: number;
    speciesid: string;
    user_input_needed: number;
    file_name?: string;
    file_path?: string;
    download_ready?: number;
    species_upov?: string;
    title?: string;
    specieid?: string;
    outcomestatus?: string;
    article?: string;
    subheading?: string;
    description?: string;
    decisiondate?: string;
    deno_valid?: number;
  }

  const getClassNames = (rowOriginal: IRow) => {
    return rowOriginal.specieclasses;
  };

  const getCountryName = (rowOriginal: IRow) => {
    return rowOriginal.countryname;
  };

  const getRegisterTypeName = (rowOriginal: IRow) => {
    return rowOriginal.registertypename;
  };

  const getRegisteredWithOther = (rowOriginal: IRow, iconRender: any) => {
    if (rowOriginal.registeredwithother === 1) {
      return iconRender;
    }
  };

  const getFirst = (arraySmt: string[]) => {
    return arraySmt[0];
  };

  const infoCircleIcon = (
    <FontAwesomeIcon
      icon={["fas", "info-circle"]}
      className={classes.infoCircle}
    />
  );

  const [compactView, setCompactView] = useSettings("compactView", false);

  const [localPageSize, setLocalPageSize] = useSettings(
    origin === tableOrigin.TEST_DATA_SHEET
      ? "testDataSheetPageSize"
      : "tablePageSize",
    origin === tableOrigin.TEST_DATA_SHEET ? 500 : 50
  );
  const [tableColumns, setTableColumns] = useState(
    origin === tableOrigin.SEARCH_VARIETIES
      ? [].concat(columns).slice(1)
      : columns
  );

  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    canPreviousPage,
    canNextPage,
    nextPage,
    previousPage,
    gotoPage,
    setPageSize,
    selectedFlatRows,
    state: { pageIndex, pageSize, sortBy },
  } = useTable(
    {
      columns,
      data,
      manualPagination: true,
      manualSortBy: true,
      pageCount: controlledPageCount,
      autoResetPage: false,
      initialState: {
        pageIndex: 0,
        pageSize: localPageSize,
        sortBy: initialSortBy,
        hiddenColumns: columns
          .filter((item: any) => !item.enabled)
          .map((item: any) => {
            return item.name;
          }),
      },
    },
    useSortBy,
    useColumnOrder,
    usePagination,
    useRowSelect
  );

  const dataRef = React.useRef();
  dataRef.current = data;

  // reset pages when changing page size or order
  const prevPageSize = usePrevious(pageSize);
  const prevData = usePrevious(data);
  const prevSortBy = usePrevious(sortBy);
  const prevFormValues = usePrevious(formValues);

  const alert = useAlert();

  // Listen for changes in pagination and use the state to fetch our new data
  React.useEffect(() => {
    if (prevPageSize !== pageSize) {
      setLocalPageSize(pageSize);
    }
    if (
      pageIndex > 0 &&
      (prevFormValues !== formValues ||
        prevSortBy !== sortBy ||
        prevPageSize !== pageSize)
    ) {
      gotoPage(0);
    } else {
      fetchData({
        pageIndex,
        pageSize,
        sortBy,
        values: formValues,
        tableColumns,
      });
    }
  }, [fetchData, pageSize, pageIndex, sortBy, formValues, tableColumns]);

  const currentRangeStart = controlledTotalCount ?
      pageSize > 0 ?
          pageIndex * pageSize + 1
        : 0
    : 1;
  const currentRangeEnd =
    pageSize > 0 ?
      (pageIndex + 1) * pageSize > controlledTotalCount
        ? controlledTotalCount
        : (pageIndex + 1) * pageSize
    : controlledTotalCount;
  const paginator = (
    <div className={classes.pagination}>
      <Form.Control
        id="resultsRecordsPerPage"
        as="select"
        custom
        size="sm"
        className={classes.paginationSelect}
        value={pageSize}
        onChange={(e) => {
          setPageSize(Number(e.target.value));
        }}
      >
        {pageSizeOptions.map((size: number) => (
          <option key={size} value={size}>
            {size < 0 ?
                t("all")
              : origin === tableOrigin.TEST_DATA_SHEET ? `${t("top")} ${size}` : size}
          </option>
        ))}
      </Form.Control>
      {origin !== tableOrigin.TEST_DATA_SHEET ? (
        <>
          <span className={classes.perPage}>{t("records_per_page")}</span>
          <span className={classes.currentCount}>
            {t("paginator_range", {
              start: currentRangeStart,
              end: currentRangeEnd,
              total: controlledTotalCount,
            })}
          </span>
          <Button
            id="resultsPreviousPage"
            onClick={() => previousPage()}
            style={{ padding: "0 5px" }}
            disabled={!canPreviousPage}
            variant="link"
          >
            <FontAwesomeIcon
              icon={["fas", "chevron-left"]}
              className={classes.paginationChevron}
            />
          </Button>
          <Button
            id="resultsNextPage"
            onClick={() => {
              if ((pageIndex + 1) * pageSize < 50000) {
                nextPage();
              } else {
                alert({
                  catchOnCancel: false,
                  title: t("alert"),
                  body: t("redefine_search"),
                });
              }
            }}
            style={{ padding: "0 5px" }}
            disabled={!canNextPage}
            variant="link"
          >
            <FontAwesomeIcon
              icon={["fas", "chevron-right"]}
              className={classes.paginationChevron}
            />
          </Button>
        </>
      ) : (
        <span className={classes.perPage}>
          {t("total")} {fakeCount}
        </span>
      )}
    </div>
  );

  const [modalState, setModalState] = useState(false);
  const handleVarietyDataSheetModalClose = React.useCallback(() => {
    setModalState(false);
  }, []);
  const [modalProps, setModalProps] = useState<JSX.Element | null>(null);

  const [activeTestDataSheetIndex, setActiveTestDataSheetIndex] = useState<
    number | null
  >(null);
  const handleTestDataSheetModalClose = React.useCallback(() => {
    setActiveTestDataSheetIndex(null);
    setTestModalState(false);
  }, []);
  const [testModalState, setTestModalState] = useState(false);

  const testDataSheetPrevious = React.useCallback(({ currentIndex }) => {
    if (dataRef.current) {
      // @ts-ignore
      const newCurrentIndex = [...dataRef.current]
        .slice(0, currentIndex)
        .map((test: any) => test.test_status === 0)
        .lastIndexOf(true);

      if (newCurrentIndex < 0) {
        return;
      }

      setActiveTestDataSheetIndex(newCurrentIndex);
    }
  }, []);

  const testDataSheetNext = React.useCallback(({ currentIndex }) => {
    if (dataRef.current) {
      // @ts-ignore
      let newCurrentIndex = [...dataRef.current]
        .slice(currentIndex + 1)
        .findIndex(
          (test: any) =>
            test[testDenominationFields.TEST_STATUS] ===
            testDenominationStatus.OK
        );

      if (newCurrentIndex < 0) {
        return;
      }

      newCurrentIndex = currentIndex + newCurrentIndex + 1;

      setActiveTestDataSheetIndex(newCurrentIndex);
    }
  }, []);

  const testDataSheetModal = (currentIndex: number) => {
    setActiveTestDataSheetIndex(currentIndex);
    setTestModalState(true);
  };

  const indicativeCommonNames = (inp: any, prefix: any) => {
    if (inp === null) {
      return "";
    }
    return `${prefix}: ${inp}`;
  };

  const [
    activeVarietyDatasheet,
    setActiveVarietyDatasheet,
  ] = useState<IActiveDatasheet | null>(null);
  const [openModalNextPage, setOpenModalNextPage] = useState(false);
  const [openModalPreviousPage, setOpenModalPreviousPage] = useState(false);

  const varietyDataSheetPrevious = React.useCallback(
    ({ currentIndex }) => {
      setModalState(false);
      setModalProps(null);
      const newCurrentIndex = currentIndex - 1;
      if ((pageSize < 0 && currentIndex - 1 < 0) || (pageSize > 0 && (pageIndex * pageSize + currentIndex - 1 < 0))) {
        return;
      } else if (newCurrentIndex < 0) {
        previousPage();
        setOpenModalPreviousPage(true);
        return;
      }
      setActiveVarietyDatasheet({
        countryid: data[newCurrentIndex].countryid,
        publicationextraid: data[newCurrentIndex].publicationextraid,
        publicationtype: data[newCurrentIndex].publicationtype,
        varietyid:
          origin === tableOrigin.TEST_DATA_SHEET
            ? `${data[newCurrentIndex].var_id}`
            : data[newCurrentIndex].varietyid,
        currentIndex: newCurrentIndex,
        totalIndex: pageSize > 0 ? pageIndex * pageSize + currentIndex : currentIndex,
        totalCount: controlledTotalCount,
        denomination: data[newCurrentIndex].denomination,
        fromArrow: true,
        fromSearchVarieties: origin === tableOrigin.SEARCH_VARIETIES
      });
    },
    [data, pageIndex, pageSize, controlledTotalCount]
  );

  const varietyDataSheetNext = React.useCallback(
    ({ currentIndex }) => {
      setModalState(false);
      setModalProps(null);

      let newCurrentIndex = currentIndex + 1;

      if ((pageSize < 0 && currentIndex + 2 > controlledTotalCount) || (pageSize > 0 && ((pageIndex * pageSize) + currentIndex + 2 > controlledTotalCount))) {
        return;
      } else if (pageSize > 0 && newCurrentIndex >= pageSize) {
        newCurrentIndex = 0;
        nextPage();
        setOpenModalNextPage(true);
        return;
      }
      setActiveVarietyDatasheet({
        countryid: data[newCurrentIndex].countryid,
        publicationextraid: data[newCurrentIndex].publicationextraid,
        publicationtype: data[newCurrentIndex].publicationtype,
        varietyid:
          origin === tableOrigin.TEST_DATA_SHEET
            ? `${data[newCurrentIndex].var_id}`
            : data[newCurrentIndex].varietyid,
        currentIndex: newCurrentIndex,
        totalIndex: pageSize > 0 ? pageIndex * pageSize + currentIndex + 2 : currentIndex + 2,
        totalCount: controlledTotalCount,
        denomination: data[newCurrentIndex].denomination,
        fromArrow: true,
        fromSearchVarieties: origin === tableOrigin.SEARCH_VARIETIES
      });
    },
    [data, pageIndex, pageSize, controlledTotalCount]
  );

  React.useEffect(() => {
    if (
      controlledTotalCount > 0 &&
      pageSize > 0 &&
      prevData !== undefined &&
      prevData !== data &&
      data.length
    ) {
      if (openModalNextPage) {
        setActiveVarietyDatasheet({
          countryid: data[0].countryid,
          publicationextraid: data[0].publicationextraid,
          publicationtype: data[0].publicationtype,
          varietyid:
            origin === tableOrigin.TEST_DATA_SHEET
              ? `${data[0].var_id}`
              : data[0].varietyid,
          currentIndex: 0,
          totalIndex: pageIndex * pageSize + 1,
          totalCount: controlledTotalCount,
          denomination: data[0].denomination,
          fromArrow: true,
          fromSearchVarieties: origin === tableOrigin.SEARCH_VARIETIES
        });
        setOpenModalNextPage(false);
      } else if (openModalPreviousPage) {
        setActiveVarietyDatasheet({
          countryid: data[pageSize - 1].countryid,
          publicationextraid: data[pageSize - 1].publicationextraid,
          publicationtype: data[pageSize - 1].publicationtype,
          varietyid:
            origin === tableOrigin.TEST_DATA_SHEET
              ? `${data[pageSize - 1].var_id}`
              : data[pageSize - 1].varietyid,
          currentIndex: pageSize - 1,
          totalIndex: (pageIndex + 1) * pageSize,
          totalCount: controlledTotalCount,
          denomination: data[pageSize - 1].denomination,
          fromArrow: true,
          fromSearchVarieties: origin === tableOrigin.SEARCH_VARIETIES
        });
        setOpenModalPreviousPage(false);
      }
    }
  }, [
    data,
    pageIndex,
    pageSize,
    controlledTotalCount,
    openModalPreviousPage,
    openModalNextPage,
  ]);

  React.useEffect(() => {
    if (
      activeVarietyDatasheet === null ||
      Object.keys(activeVarietyDatasheet).length === 0
    ) {
      return;
    }

    setModalState(true);

    setModalProps(
      <VarietyDataSheet
        currentIndex={activeVarietyDatasheet.currentIndex}
        totalIndex={activeVarietyDatasheet.totalIndex}
        totalCount={activeVarietyDatasheet.totalCount}
        varietyDataSheetNext={varietyDataSheetNext}
        varietyDataSheetPrevious={varietyDataSheetPrevious}
        countryid={activeVarietyDatasheet.countryid}
        publicationextraid={activeVarietyDatasheet.publicationextraid}
        publicationtype={activeVarietyDatasheet.publicationtype}
        varietyid={activeVarietyDatasheet.varietyid}
        name={activeVarietyDatasheet.denomination}
        fromArrow={activeVarietyDatasheet.fromArrow}
        fromSearchVarieties={activeVarietyDatasheet.fromSearchVarieties}
      />
    );
  }, [activeVarietyDatasheet]);

  const varietyDataSheetModal = (
    countryid: string,
    publicationextraid: number,
    publicationtype: string,
    varietyid: string,
    currentIndex: number,
    totalIndex: number,
    total: number,
    denomination: string
  ) => {
    setModalState(true);

    setActiveVarietyDatasheet({
      countryid: countryid,
      publicationextraid: publicationextraid,
      publicationtype: publicationtype,
      varietyid: varietyid,
      currentIndex: currentIndex,
      totalIndex: totalIndex,
      totalCount: total,
      denomination: denomination,
      fromArrow: false,
      fromSearchVarieties: origin === tableOrigin.SEARCH_VARIETIES
    });
  };

  const [classModalState, setClassModalState] = useState(false);
  const [activeClassId, setActiveClassId] = useState<string | null>(null);

  React.useEffect(() => {
    if (!activeClassId) {
      return;
    }

    setClassModalState(true);
  }, [activeClassId]);

  const classModal = (
    <SpeciesClassModal
      show={classModalState}
      setShow={setClassModalState}
      classid={activeClassId}
    />
  );

  const [speciesModalState, setSpeciesModalState] = useState(false);
  const [activeSpecies, setActiveSpecies] = useState<IActiveSpecies | null>(
    null
  );

  React.useEffect(() => {
    if (!activeSpecies) {
      return;
    }

    setSpeciesModalState(true);
  }, [activeSpecies]);

  const speciesModal = (
    <SpeciesModal
      show={speciesModalState}
      setShow={setSpeciesModalState}
      princ_bot={activeSpecies?.princ_bot}
      species_id={activeSpecies?.species_id}
      species_upov={activeSpecies?.species_upov}
      data={activeSpecies?.data}
    />
  );

  const [jurisprudenceModalState, setJurisprudenceModalState] = useState(false);
  const [activeJurisprudence, setActiveJurisprudence] = useState<IActiveJurisprudenceModal | null>(null);

  React.useEffect(() => {
    if (!activeJurisprudence) {
      return;
    }

    setJurisprudenceModalState(true);
  }, [activeJurisprudence]);

  const jurisprudenceModal = (
    <JurisprudenceModal
      show={jurisprudenceModalState}
      setShow={setJurisprudenceModalState}
      title={activeJurisprudence?.title}
      decision_date={activeJurisprudence?.decision_date}
      outcome={activeJurisprudence?.outcome}
      article={activeJurisprudence?.article}
      subheading={activeJurisprudence?.subheading}
      denomination={activeJurisprudence?.denomination}
      species_name={activeJurisprudence?.species_name}
      description={activeJurisprudence?.description}
    />
  );


  const [registerModalState, setRegisterModalState] = useState(false);
  const [activeRegister, setActiveRegister] = useState<IActiveRegister | null>(null);

  React.useEffect(() => {
    if (!activeRegister) {
      return;
    }

  setRegisterModalState(true);
  }, [activeRegister]);

  const registersModal = (
    <RegistersModal
      show={registerModalState}
      setShow={setRegisterModalState}
      countryid = {activeRegister?.countryid}
      publicationtypeid={activeRegister?.publicationtypeid}
      publicationextraid={activeRegister?.publicationextraid}
      data={activeRegister?.data}
    />
  );

  const myModal = (
    <CustomModal show={modalState} onHide={handleVarietyDataSheetModalClose}>
      {modalProps}
    </CustomModal>
  );

  const testModal = (
    <CustomModal show={testModalState} onHide={handleTestDataSheetModalClose} size={"lg"}>
      {activeTestDataSheetIndex !== null ? (
        <TestDataSheet
          onUpdateReqAdvice={updateReqAdvice}
          currentIndex={activeTestDataSheetIndex}
          totalIndex={
            [...data.slice(0, activeTestDataSheetIndex + 1)].filter(
              (test: any) =>
                test[testDenominationFields.TEST_STATUS] ===
                testDenominationStatus.OK
            ).length
          }
          count={data.filter((test: any) => test.test_status === 0).length}
          testDataSheetNext={testDataSheetNext}
          testDataSheetPrevious={testDataSheetPrevious}
          test_id={
            origin === tableOrigin.TEST_DENOMINATION
              ? data[activeTestDataSheetIndex].test_id
              : data[activeTestDataSheetIndex].testid
          }
          {...data[activeTestDataSheetIndex]}
          breeder_name={origin === tableOrigin.TEST_DENOMINATION
                          ? data[activeTestDataSheetIndex].breeder_name
                          : data[activeTestDataSheetIndex].breedername
                        }
          breeder_ref={origin === tableOrigin.TEST_DENOMINATION
                        ? data[activeTestDataSheetIndex].breeder_ref
                        : data[activeTestDataSheetIndex].breederreference
                      }
          species_id={origin === tableOrigin.TEST_DENOMINATION
                        ? data[activeTestDataSheetIndex].species_id
                        : data[activeTestDataSheetIndex].speciesid
                      }
          species_latin_name={origin === tableOrigin.TEST_DENOMINATION
                                ? data[activeTestDataSheetIndex].species_latin_name
                                : data[activeTestDataSheetIndex].species_name
                              }
        />
      ) : (
        <></>
      )}
    </CustomModal>
  );

const tableActions = (
  <Row ref={tableRef} className={classes.tableHeader}>
    <Col md="12">
      <Row>
        <Col md={modal ? 5 : 8} className={classes.tableActions}>
          {!hideColumnsButton ? (
            <CustomSortablePopover
              id="results-columns-reorder"
              placement="right"
              firstItemDisabled={true}
              onPopoverExited={setTableColumns}
              items={tableColumns}
            >
              <Button
                id="configureResultsColumns"
                variant="light"
                className={classes.tableAction}
              >
                <ColumnsIcon
                  className={[
                    classes.columnsIcon,
                    classes.icon,
                    "align-middle",
                  ].join(" ")}
                />
                {t("columns")}
              </Button>
            </CustomSortablePopover>
          ) : (
            <></>
          )}
          <Button
            id="compactViewToggle"
            onClick={() => setCompactView(!compactView)}
            variant="light"
            className={classes.tableAction}
          >
            <LineHeightIcon
              className={[
                classes.lineHeightIcon,
                classes.icon,
                "align-middle",
              ].join(" ")}
            />
            {compactView ? t("compact_view") : t("default_view")}
          </Button>
          {!hideDownloadExcelButton ? (
            <Button
              id="downloadExcel"
              onClick={() => {
                downloadExcel({ values: formValues });
              }}
              variant="light"
              className={classes.tableAction}
            >
              <FontAwesomeIcon
                icon={["fas", "arrow-alt-circle-down"]}
                className={[
                  classes.downloadIcon,
                  classes.icon,
                  "align-middle",
                ].join(" ")}
              />
              {t("download_excel")}
            </Button>
          ) : (
            <></>
          )}
          {origin === tableOrigin.TEST_DENOMINATION || origin === tableOrigin.CONTRIBUTIONS? (
            <Button
              id="refreshData"
              onClick={() => {
                refreshData();
              }}
              variant="light"
              className={classes.tableAction}
            >
              <FontAwesomeIcon
                icon={["fas", "sync-alt"]}
                className={[
                  classes.refreshIcon,
                  classes.icon,
                  "align-middle",
                ].join(" ")}
              />
              {t("refresh")}
            </Button>
          ) : (
            <></>
          )}
          {origin === tableOrigin.TEST_DATA_SHEET ? (
            <Button
              id="selectedData"
              onClick={() => {
                selectedData({
                  data: selectedFlatRows.map(
                    (d) => (d.original as IRow).var_id
                  ),
                });
              }}
              variant="light"
              className={classes.tableAction}
            >
              <FontAwesomeIcon
                icon={["fas", "file-export"]}
                className={[
                  classes.downloadIcon,
                  classes.icon,
                  "align-middle",
                ].join(" ")}
              />
              {t("download_selected")}
            </Button>
          ) : (
            <></>
          )}
          {modal ? (
            <Button
              id="selectedData"
              onClick={() => {
                selectedData({
                  data: selectedFlatRows.map(
                    (d) => d.original
                  ),
                });
              }}
              variant="primary"
              disabled={selectedFlatRows.length === 0}
              className={classes.selectAction}
            >
              <FontAwesomeIcon
                icon={["fas", "check-circle"]}
                className={[
                  classes.downloadIcon,
                  classes.icon,
                  "align-middle",
                ].join(" ")}
              />
              {t("select")}
            </Button>
          ) : (
            <></>
          )}
          {origin === tableOrigin.MY_TESTS ? (
            <Button
              id="selectedData"
              onClick={() => {
                selectedData({
                  data: selectedFlatRows.map((d) => d.original),
                });
              }}
              variant="light"
              className={classes.tableAction}
            >
              <FontAwesomeIcon
                icon={["fas", "file-export"]}
                className={[
                  classes.downloadIcon,
                  classes.icon,
                  "align-middle",
                ].join(" ")}
              />
              {t("download_selected")}
            </Button>
          ) : (
            <></>
          )}
          {origin === tableOrigin.MY_TESTS && isAdvanced() ? (
            <Button
              id="requestBulkAdvice"
              disabled={
                selectedFlatRows.length === 0 ||
                selectedFlatRows.filter(
                  (d) =>
                    (d.original as IRow).request_advice_id === 1 &&
                    checkToday((d.original as IRow).test_date)
                ).length !== selectedFlatRows.length
              }
              onClick={() => {
                requestBulkAdvice({
                  data: selectedFlatRows.map(
                    (d) => (d.original as IRow).testid
                  ),
                });
              }}
              variant="light"
              className={classes.tableAction}
            >
              <FontAwesomeIcon
                icon={["fas", "comment"]}
                className={[
                  classes.downloadIcon,
                  classes.icon,
                  "align-middle",
                ].join(" ")}
              />
              {t("request_advice_button")}
            </Button>
          ) : (
            <></>
          )}
          {origin === tableOrigin.MY_TESTS ? (
            <>
              <Button
                id="deleteTests"
                disabled={
                  selectedFlatRows.length === 0 ||
                  selectedFlatRows.filter(
                    (d) => (d.original as IRow).request_advice_id === 1
                  ).length !== selectedFlatRows.length
                }
                onClick={() => {
                  deleteTests({
                    data: selectedFlatRows.map(
                      (d) => (d.original as IRow).testid
                    ),
                  });
                }}
                variant="light"
                className={classes.tableAction}
              >
                <FontAwesomeIcon
                  icon={["fas", "trash-alt"]}
                  className={[
                    classes.downloadIcon,
                    classes.icon,
                    "align-middle",
                  ].join(" ")}
                />
                {t("delete")}
              </Button>
              {!formValues.archivedTests ? (
                <Button
                  id="archiveTests"
                  disabled={
                    selectedFlatRows.length === 0 ||
                    selectedFlatRows.filter(
                      (d) => (d.original as IRow).test_archived === 0
                    ).length !== selectedFlatRows.length
                  }
                  onClick={() => {
                    archiveTests({
                      data: selectedFlatRows.map(
                        (d) => (d.original as IRow).testid
                      ),
                    });
                  }}
                  variant="light"
                  className={classes.tableAction}
                >
                  <FontAwesomeIcon
                    icon={["fas", "archive"]}
                    className={[
                      classes.downloadIcon,
                      classes.icon,
                      "align-middle",
                    ].join(" ")}
                  />
                  {t("archive")}
                </Button>
              ) : (
                <></>
              )}
            </>
          ) : (
            <></>
          )}
        </Col>
        <Col md={modal ? 7 : 4}>{showPagination ? paginator : <></>}</Col>
      </Row>
    </Col>
  </Row>
)

  // Render the UI for your table
  return (
    <>
      {myModal}
      {testModal}
      {classModal}
      {speciesModal}
      {registersModal}
      {jurisprudenceModal}
      {tableActions}
      {origin === tableOrigin.TEST_DATA_SHEET || (origin === tableOrigin.SEARCH_VARIETIES && !isFullSearchExp()) ? (
        <div className={`d-flex ${origin === tableOrigin.SEARCH_VARIETIES ? classes.searchVarietiesTabs : ''}`}>
          <Button
            variant="custom"
            onClick={() => changeTab(0)}
            className={activeTab === 0 ? classes.tabActive : classes.tab}
          >
            {origin === tableOrigin.TEST_DATA_SHEET ? t("denomination", {count: 2}) : t("non_commercial")}
          </Button>{" "}
          <Button
            variant="custom"
            onClick={() => changeTab(1)}
            className={activeTab === 1 ? classes.tabActive : classes.tab}
          >
            {origin === tableOrigin.TEST_DATA_SHEET ? t("eutm") : t("commercial")}
          </Button>
        </div>
      ) : (
        <></>
      )}
      <div className={[classes.horizontalScrolling, classes.maxTableHeight, origin === tableOrigin.TEST_DATA_SHEET ? classes.verticalScrolling : ""].join(" ")}>
      <BTable
        hover
        size="sm"
        className={[
          classes.table,
          firstColumnWithoutHeader ? classes.firstColumnWithoutHeader : "",
          compactView ? classes.compact : "",
        ].join(" ")}
        {...getTableProps()}
      >
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column: ColumnInstance) => (
                <th
                  {...column.getHeaderProps(
                    isSortable ? column.getSortByToggleProps() : ""
                  )}
                >
                  <span
                    className={
                      column.id === myTestsReturnTypes.TEST_STATUS
                        ? "d-flex justify-content-center"
                        : ""
                    }
                  >
                    {column.id === TABLE_SELECT_ROW
                      ? column.render("Header")
                      : (column as CustomColumnInstance).label}
                    <span>
                      {column.isSorted ? (
                        column.isSortedDesc ? (
                          <FontAwesomeIcon
                            icon={["fas", FONTAWESOME_ICON_NAMES.CHEVRON_DOWN]}
                            className={classes.chevron}
                          />
                        ) : (
                          <FontAwesomeIcon
                            icon={["fas", FONTAWESOME_ICON_NAMES.CHEVRON_UP]}
                            className={classes.chevron}
                          />
                        )
                      ) : (
                        ""
                      )}
                    </span>
                  </span>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row, i) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell) => {
                  return (
                    <td {...cell.getCellProps()}>
                      {(() => {
                        if (
                          origin === tableOrigin.SEARCH_SPECIES &&
                            cell.column.id ===
                              searchSpeciesReturnTypes.SPECIES_CLASS
                        ) {
                          return cell.value?.map((classData: any, index: number) => (
                              <React.Fragment key={`class-data-${index}`}>
                                {cell.value?.length > 1 ? "- " : ""}
                                <span
                                  className={classes.activeCell}
                                  onClick={() => {
                                    setActiveClassId(classData?.class_id);
                                    setClassModalState(true);
                                  }}
                                >
                                  {classData?.class_id}
                                </span>
                                {cell.value?.length > 1 && index < cell.value?.length - 1 ? <br /> : <></>}
                              </React.Fragment>
                            ));
                        } else if (
                            origin === tableOrigin.SEARCH_CLASSES &&
                              cell.column.id === searchClassesReturnTypes.CLASS_CODE
                        ) {
                          return <span
                                    className={classes.activeCell}
                                    onClick={() => {
                                      setActiveClassId(cell.value);
                                      setClassModalState(true);
                                    }}
                                  >
                                  {cell.value}
                                </span>
                        } else if (
                            origin === tableOrigin.SEARCH_SPECIES &&
                            cell.column.id ===
                              searchSpeciesReturnTypes.PRINCIPAL_BOTANICAL_NAME
                        ) {
                          const rowData = cell.row.original as IRow;
                          const otherNames = {
                                              latin: rowData["other_bot"],
                                              en: rowData["en"],
                                              de: rowData["de"],
                                              fr: rowData["fr"],
                                              es: rowData["es"],
                                            };
                          const species: IActiveSpecies = {
                            princ_bot: rowData["princ_bot"],
                            species_id: rowData["species_id"],
                            species_upov: rowData["species_upov"],
                            data: {
                              class_data: rowData["class_data"],
                              crop_sectors: rowData["crop_sectors"],
                              comments: rowData["comments"],
                              other_names: otherNames
                            }
                          };
                          return (
                            <span
                              className={classes.activeCell}
                              onClick={() => {
                                setActiveSpecies(species);
                                setSpeciesModalState(true);
                              }}
                            >
                              {cell.value}
                            </span>
                          );
                        } else if (
                          origin === tableOrigin.SEARCH_VARIETIES &&
                          cell.column.id === searchVarietyReturnTypes.SPECIES_LATIN_NAME
                        ) {
                          const rowData = cell.row.original as IRow;
                          return <span  className={classes.activeCell} onClick={() => {
                            const species: IActiveSpecies = {
                              princ_bot: rowData.specielatinname,
                              species_id: rowData.speciesid
                            }
                            setActiveSpecies(species);
                            setSpeciesModalState(true);
                          }}>{cell.value}</span>
                        } else if (
                          origin === tableOrigin.MY_TESTS &&
                          cell.column.id === myTestsReturnTypes.REQUEST_ADVICE_ID
                        ) {
                          return <AdviceStatusBadge id={cell.value} />;
                        } else if (
                          origin === tableOrigin.CONTRIBUTIONS &&
                            cell.column.id === contributionsReturnTypes.FILE_NAME
                        ) {
                          const filePath = (cell.row.original as IRow)?.file_path;
                          return <span
                            className={classes.activeCell}
                            onClick={() => {
                              if ((cell.row.original as IRow)?.download_ready === 1) {
                                graphQLClientInstance.post(API_URLS.CONTRIBUTIONS_DOWNLOAD_FILE, { key: `${filePath?.substring(filePath?.indexOf('/')+1)}/${cell.value}` })
                                .then((res) => {
                                  if (res.data?.url) {
                                    downloadUrl(res.data.url);
                                  }
                                })
                                .catch(err => console.log(err));
                              } else {
                                alert({
                                  catchOnCancel: false,
                                  title: t("alert"),
                                  body: t("file_not_available"),
                                });
                              }
                            }}>
                              {cell.value}
                            </span>;
                        } else if (
                          origin === tableOrigin.MY_TESTS &&
                          cell.column.id === myTestsReturnTypes.TEST_DATE
                        ) {
                          return <span>{convertDate(cell.value, GLOBAL_DATETIME_FORMAT)}</span>;
                        } else if (
                          origin === tableOrigin.CONTRIBUTIONS &&
                            cell.column.id === contributionsReturnTypes.UPLOAD_DATE
                        ) {
                          return <span>{convertDate(cell.value*1000, GLOBAL_DATETIME_FORMAT)}</span>;
                        } else if (
                          origin === tableOrigin.CONTRIBUTIONS &&
                            cell.column.id === contributionsReturnTypes.FILE_COMMENT
                        ) {
                          return (
                            <span style={{
                              textOverflow: 'ellipsis',
                              display: 'inline-block',
                              maxWidth: '470px',
                              overflow: 'hidden',
                              whiteSpace: 'nowrap'
                            }}>
                              <EllipsisWithTooltip>
                              {cell.value}
                              </EllipsisWithTooltip>
                            </span>
                          );
                        } else if(
                          origin === tableOrigin.MY_ALERTS &&
                          (cell.column.id === myAlertsReturnTypes.DATE_START ||
                            cell.column.id === myAlertsReturnTypes.DATE_END)
                        ) {
                          return <span>{convertDate(cell.value * 1000)}</span>;
                        } else if(
                          origin === tableOrigin.MY_ALERTS &&
                          cell.column.id === myAlertsReturnTypes.ALERT_ID
                        ) {
                          return <span>
                                  <FontAwesomeIcon
                                    onClick={() => { deleteAlert(cell.value)} }
                                    icon={['fas', 'trash-alt']}
                                    className={["align-middle", "float-right", classes.trashIcon].join(" ")}
                                    color="#808080"/>
                                </span>;
                        } else if(
                          origin === tableOrigin.MY_ALERTS &&
                          cell.column.id === myAlertsReturnTypes.COUNTRY
                        ) {
                          const rowData = (cell.row.original as IRow);
                          const countries = rowData['countries'];
                          return (
                            <>
                              {countries ?
                              (countries
                              .map((country: string, index: number) => {
                                return (
                                  country? (
                                  renderTooltipOverlayTable(
                                    <span style={{margin: "2px"}}>
                                      <Badge variant={index % 2 === 0 ? "primary" : "light"} className={classes.countryBadge}>{country}</Badge>
                                    </span>,
                                    getCountryNamesFromSession(country),
                                    `badge-${index}`
                                  )
                                  ):(<></>)
                                )
                              })
                              )
                              :
                              (<></>)}
                            </>
                          )
                        } else if(
                          origin === tableOrigin.MY_ALERTS &&
                          cell.column.id === myAlertsReturnTypes.SPECIES_CLASS_CODE
                        ) {
                          const rowData = (cell.row.original as IRow);
                          const species = rowData['species']?.filter(Boolean).map((specie: any) => ((rowData['species'].length!==1)?("- " + specie):specie)).join("<br>");
                          return <span dangerouslySetInnerHTML={{__html:species}} />
                        } else if (
                          origin === tableOrigin.JURISPRUDENCE &&
                          cell.column.id ===
                            jurisprudenceReturnTypes.DENOMINATION
                          ) {
                            const rowData = cell.row.original as IRow;
                            const jurisprudence: IActiveJurisprudenceModal = {
                              title: rowData["title"],
                              denomination: rowData["denomination"],
                              species_name: rowData["specieid"],
                              description: rowData["description"],
                              decision_date: rowData["decisiondate"],
                              subheading: rowData["subheading"],
                              article: rowData["article"],
                              outcome: rowData["outcomestatus"],
                            };
                            return (
                              <span
                                className={classes.activeCell}
                                onClick={() => {
                                  setActiveJurisprudence(jurisprudence);
                                  setJurisprudenceModalState(true);
                                }}
                              >
                                {cell.value}
                              </span>
                            );
                        } else if (
                          origin === tableOrigin.REGISTERS &&
                          cell.column.id === registersReturnTypes.COUNTRY
                        ) {
                          return (
                            <span>
                              {cell.value} - {getCountryNamesFromSession(cell.value)}
                            </span>
                          )
                        } else if (
                          origin === tableOrigin.REGISTERS &&
                          cell.column.id === registersReturnTypes.REGISTER_TYPE
                        ) {
                          return (
                            <span>
                              {cell.value?t(`register_types.${cell.value.toLowerCase()}`):""}
                            </span>
                          )
                        } else if (
                          origin === tableOrigin.REGISTERS &&
                          cell.column.id === registersReturnTypes.LAST_CONTRIBUTION_DATA
                        ) {
                          return (
                            <span>
                              {convertDate(cell.value)}
                            </span>
                          )
                        } else if (
                          (origin === tableOrigin.REGISTERS &&
                            cell.column.id ===
                            registersReturnTypes.REGISTER_NAME)
                        ) {
                          const rowData = cell.row.original as IRow;
                          const register: IActiveRegister = {
                            countryid: rowData["countryid"],
                            publicationtypeid: rowData["publicationtypeid"],
                            data: {
                              publicationname: rowData["publicationname"],
                              name: rowData["name"],
                              websiteurl: rowData["websiteurl"],
                              remarks: rowData["remarks"],
                              email: rowData["email"],
                              addressformatted: rowData["addressformatted"],
                              all_contributions: rowData["all_contributions"]
                            }
                          };
                          return (
                            <span
                              className={classes.activeCell}
                              onClick={() => {
                                setActiveRegister(register);
                                setRegisterModalState(true);
                              }}
                            >
                              {cell.value}
                            </span>
                          );
                        } else if (
                          origin === tableOrigin.TEST_DATA_SHEET
                          && cell.column.id === testResultsListReturnTypes.VARIETY_STATUS
                        ) {
                          return <span>{getVarietyStatusTranslatedText(cell.value)}</span>;
                        } else if (
                          origin === tableOrigin.TEST_DATA_SHEET
                          && (cell.column.id === testResultsListReturnTypes.DENOMINATION_SPECIES ||
                            cell.column.id === testResultsListReturnTypes.DENOMINATION)
                        ) {
                          const textValue = (cell.column.id === testResultsListReturnTypes.DENOMINATION_SPECIES) ? cell.value?.[0] : cell.value;
                          const speciesValue = (cell.column.id === testResultsListReturnTypes.DENOMINATION_SPECIES) ? (<><br /><span>{cell.value?.[1]}</span></>) : <></>;
                          const valid = (cell.row.original as IRow).deno_valid === 1;
                          return (
                            <React.Fragment>
                              {valid ?
                                <>
                                  <span
                                    onClick={() => {
                                      setModalProps(null);
                                      varietyDataSheetModal(
                                        (cell.row.original as IRow).countryid,
                                        (cell.row.original as IRow).publicationextraid,
                                        (cell.row.original as IRow).publicationtype,
                                        `${(cell.row.original as IRow).var_id}`,
                                        parseInt(cell.row.id),
                                        pageSize > 0 ?
                                            pageIndex * pageSize + parseInt(cell.row.id) + 1
                                          : parseInt(cell.row.id) + 1,
                                        controlledTotalCount,
                                        (cell.row.original as IRow).denomination
                                      );
                                    }}
                                    className={classes.activeCell}
                                    >{textValue}</span>
                                    {speciesValue}
                                  </>
                                : <>
                                    {renderTooltipOverlayTable(
                                        <span className={classes.invalidatedVariety}>
                                          {textValue}{speciesValue}
                                        </span>,
                                        t("tooltips_my_tests.invalidated")
                                    )}
                                  </>}
                            </React.Fragment>
                          );
                        } else if (
                          origin === tableOrigin.TEST_DATA_SHEET
                          && cell.column.id === testResultsListReturnTypes.DENOMINATION_STATUS
                        ) {
                          return <span>{getDenominationStatusText(cell.value)}</span>;
                        } else if (
                          cell.column.id ===
                          searchSpeciesReturnTypes.COMMON_NAME_EN
                        ) {
                          const rowData = cell.row.original as IRow;
                          const commonNames = [
                            indicativeCommonNames(
                              rowData["en"],
                              "EN"
                            ),
                            indicativeCommonNames(
                              rowData["fr"],
                              "FR"
                            ),
                            indicativeCommonNames(
                              rowData["de"],
                              "DE"
                            ),
                            indicativeCommonNames(
                              rowData["es"],
                              "ES"
                            ),
                          ].filter(Boolean);
                          const commonNamesHTML = commonNames.map((translation: string) => {
                            return `${commonNames.length>1?"- ":""}${translation}`
                          })
                            .join("<br>");
                          return (
                            <span
                              dangerouslySetInnerHTML={{ __html: commonNamesHTML }}
                            />
                          );
                        } else if (
                          cell.column.id ===
                          searchSpeciesReturnTypes.OTHER_BOTANICAL_NAMES
                        ) {
                          const rowData = cell.row.original as IRow;
                          const otherBotanicalNames =
                            (rowData["other_bot"] && rowData["other_bot"].length)
                              ? rowData["other_bot"]
                                  .filter(Boolean)
                                  //@ts-ignore
                                  .map((translation) => ((rowData["other_bot"]?.length>1)?("- " + translation):(translation)))
                                  .join("<br>")
                              : "";
                          return (
                            <span
                              dangerouslySetInnerHTML={{
                                __html: otherBotanicalNames,
                              }}
                            />
                          );
                        } else if (
                          cell.column.id === searchVarietyReturnTypes.COUNTRIES
                        ) {
                          return renderTooltipOverlayTable(
                            <span className={classes.underlineTooltip}>
                              {cell.render("Cell")}
                            </span>,
                            <span>
                              {getCountryName(cell.row.original as IRow)}
                            </span>
                          );
                        } else if (
                          cell.column.id ===
                          searchVarietyReturnTypes.SPECIES_NAME_EN
                        ) {
                          return (
                            <span>
                              {cell.value?.filter(Boolean).join(", ")}
                            </span>
                          );
                        } else if (
                          cell.column.id ===
                            searchVarietyReturnTypes.SPECIES_CROP_SECTOR ||
                          cell.column.id ===
                            searchVarietyReturnTypes.BREEDERS_NAME
                        ) {
                          return (
                            <span>
                              {cell.value
                                ?.trim()
                                .split("^^^")
                                .map((x: string) => x.trim())
                                .join(", ")}
                            </span>
                          );
                        } else if (
                          cell.column.id ===
                          searchVarietyReturnTypes.REGISTER_TYPE
                        ) {
                          return renderTooltipOverlayTable(
                            <span className={classes.underlineTooltip}>
                              {cell.render("Cell")}
                            </span>,
                            <span>
                              {getRegisterTypeName(cell.row.original as IRow)}
                            </span>
                          );
                        } else if (
                          cell.column.id ===
                          searchVarietyReturnTypes.SPECIES_CLASS_CODE
                        ) {
                          const classNames = getClassNames(
                            cell.row.original as IRow
                          );
                          if (classNames !== null) {
                            const tooltipContent = classNames?.map(
                              (item: any, index: number) => {
                                return (
                                  (classNames && classNames.length>1) ? (
                                  <div
                                    key={`species-code-tooltip-${index}`}
                                    data-html="true"
                                    className={classes.linebreakTooltip}
                                  >- {item}
                                  </div>
                                  ): (
                                    <div
                                    key={`species-code-tooltip-${index}`}
                                    data-html="true"
                                    className={classes.linebreakTooltip}
                                  >{item}
                                  </div>
                                  )
                                );
                              }
                            )
                            return <span>
                                {renderTooltipOverlayTable(
                                  <>
                                    <span
                                      style={{cursor: 'pointer'}}
                                      className={classes.underlineTooltip}
                                      onClick={() => {
                                        setActiveClassId(getFirst(cell.value));
                                        setClassModalState(true);
                                      }}>
                                      {getFirst(cell.value)}
                                    </span>
                                    {classNames?.length > 1 ?
                                      <span>
                                        {` (+)`}
                                      </span>
                                    : <></>}
                                  </>,
                                  <span>{tooltipContent}</span>
                                )}
                              </span>;
                          } else {
                            return <span></span>;
                          }
                        } else if (
                          cell.column.id ===
                          testResultsListReturnTypes.VARIETY_STATUS_DATE
                        ) {
                          return (
                            <span>
                              {convertDate(
                                cell.value,
                                GLOBAL_DATE_FORMAT,
                                "YYYY-MM-DDTHH:mm:ssZ"
                              )}
                            </span>
                          );
                        } else if (
                          cell.column.id ===
                          myTestsReturnTypes.USER_INPUT_NEEDED
                        ) {
                          // @ts-ignore
                          const iconRender = cell.render(infoCircleIcon);
                          return renderTooltipOverlayTable(
                            <span>
                              {(cell.row.original as IRow).user_input_needed === 1 ?
                                iconRender
                              : <></>}
                            </span>,
                            <span>{t("user_input_needed")}</span>
                          );
                        } else if (
                          cell.column.id ===
                          searchVarietyReturnTypes.DENOMINATION_SYNONYM
                        ) {
                          // @ts-ignore
                          const iconRender = cell.render(infoCircleIcon);
                          return renderTooltipOverlayTable(
                            <span>
                              {getRegisteredWithOther(
                                cell.row.original as IRow,
                                iconRender
                              )}
                            </span>,
                            <span>{t("registered_synonym")}</span>
                          );
                        } else if (
                          cell.column.id === testDenominationFields.ADDITIONAL_INFORMATION
                        ) {
                          return (
                            <span dangerouslySetInnerHTML={{__html: cell.value?.replace(/\n/g,"<br>")}}/>
                          );
                        }else if (
                          cell.column.id === testDenominationFields.TEST_STATUS
                        ) {
                          // @ts-ignore
                          let iconRender = cell.render(infoCircleIcon);
                          if (cell.value === 0) {
                            iconRender = (
                              <FontAwesomeIcon
                                className={[classes.checkCircleIcon].join(" ")}
                                icon={["fas", "check-circle"]}
                              />
                            );
                          } else if (cell.value === -1) {
                            iconRender = (
                              <Spinner animation="border" size="sm" />
                            );
                          } else {
                            iconRender = (
                              <FontAwesomeIcon
                                className={[classes.exclamationCircleIcon].join(
                                  " "
                                )}
                                icon={["fas", "exclamation-circle"]}
                              />
                            );
                          }
                          return (
                            <span className="d-flex justify-content-center">
                              {iconRender}
                            </span>
                          );
                        } else if (cell.column.id === TABLE_SELECT_ROW) {
                          return <span>{cell.render("Cell")}</span>;
                        } else if (
                          origin === tableOrigin.SEARCH_SPECIES &&
                          cell.column.id ===
                            searchSpeciesReturnTypes.CROP_SECTOR
                        ) {
                          return (
                            <span>{cell.value?.filter(Boolean).join("/")}</span>
                          );
                        } else if (
                          origin === tableOrigin.SEARCH_VARIETIES &&
                          [
                            searchVarietyReturnTypes.APPLICANT,
                            searchVarietyReturnTypes.MAINTAINER,
                            searchVarietyReturnTypes.HOLDER,
                            searchVarietyReturnTypes.OTHER_PARTIES,
                            searchVarietyReturnTypes.SPECIES_CLASS_NAME,
                          ].includes(cell.column.id)
                        ) {
                          return (
                            <span
                              dangerouslySetInnerHTML={{
                                __html: cell.value
                                  ?.filter(Boolean)
                                  .map((val: any) =>
                                    cell.value.length !== 1 ? "- " + val : val
                                  )
                                  .join("<br>"),
                              }}
                            />
                          );
                        } else {
                          let cellValue = cell.value;
                          if (
                            (cell.column as CustomColumnInstance).dataType &&
                            (cell.column as CustomColumnInstance).dataType ===
                              "date"
                          ) {
                            cellValue = convertDate(
                              cellValue,
                              GLOBAL_DATE_FORMAT,
                              "YYYYMMDD"
                            );
                          } else if (
                            origin === tableOrigin.SEARCH_VARIETIES &&
                            (cell.column.id === searchVarietyReturnTypes.DENOMINATION ||
                              cell.column.id === searchVarietyReturnTypes.APPLICATION_NUMBER)
                          ) {
                            return (
                              <span
                                onClick={() => {
                                  setModalProps(null);
                                  varietyDataSheetModal(
                                    (cell.row.original as IRow).countryid,
                                    (cell.row.original as IRow)
                                      .publicationextraid,
                                    (cell.row.original as IRow).publicationtype,
                                    (cell.row.original as IRow).varietyid,
                                    parseInt(cell.row.id),
                                    pageIndex * pageSize +
                                      parseInt(cell.row.id) +
                                      1,
                                    controlledTotalCount,
                                    (cell.row.original as IRow).denomination
                                  );
                                }}
                                className={classes.activeCell}
                              >
                                {cellValue}
                              </span>
                            );
                          } else if (
                            (origin === tableOrigin.TEST_DENOMINATION &&
                              cell.column.id ===
                                testDenominationFields.DENOMINATION &&
                              (cell.row.original as IRow).test_status ===
                                testDenominationStatus.OK) ||
                            (origin === tableOrigin.MY_TESTS &&
                              cell.column.id ===
                                myTestsReturnTypes.DENOMINATION &&
                              (cell.row.original as IRow).test_status ===
                                testDenominationStatus.OK)
                          ) {
                            return (
                              <span
                                onClick={() => {
                                  testDataSheetModal(parseInt(cell.row.id));
                                }}
                                className={classes.activeCell}
                              >
                                {cellValue}
                              </span>
                            );
                          }
                          return <span>{cellValue}</span>;
                        }
                      })()}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </BTable>
      </div>
      {modal || showTableActionsBottom ? (
        <>
          {tableActions}
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default Table;

interface CustomColumnInstance extends ColumnInstance {
  label: string;
  dataType?: string;
}

interface IActiveDatasheet {
  countryid: string;
  publicationextraid: number;
  publicationtype: string;
  varietyid: string;
  currentIndex: number;
  totalIndex: number;
  totalCount: number;
  denomination: string;
  fromArrow?: boolean;
  fromSearchVarieties?: boolean;
}

export interface IActiveRegister {
  countryid?: string;
  publicationtypeid?: string;
  publicationextraid?: string;
  data?: {
    publicationname?: string;
    name?: string;
    websiteurl?: string;
    remarks?: string;
    email?: string;
    addressformatted?: string;
    all_contributions?: IActiveRegisterContribution[];
  }
}

export interface IActiveRegisterContribution {
    pub_date?: string;
    pub_info?: string;
    pub_number?: string;
}

export interface IActiveSpecies {
  princ_bot?: string;
  species_id?: string;
  species_upov?: string;
  data?: {
    crop_sectors?: string[];
    class_data?: {
      classid?: string;
      class_name?: string;
      class_type?: string;
      class_type_value?: string | number;
    }[];
    comments?: string;
    other_names?: IActiveSpeciesOtherNames;
  }
}

export interface IActiveSpeciesOtherNames {
  latin?: string[];
  en?: string[];
  fr?: string[];
  de?: string[];
  es?: string[];
}

export const tableOrigin = {
  SEARCH_VARIETIES: "searchVarieties",
  SEARCH_SPECIES: "searchSpecies",
  SEARCH_CLASSES: "searchClasses",
  TEST_DATA_SHEET: "testDatasheet",
  TEST_DENOMINATION: "testDenomination",
  MY_TESTS: "myTests",
  MY_ALERTS: "myAlerts",
  REGISTERS: "registers",
  CONTRIBUTIONS: "contributions",
  JURISPRUDENCE: "jurisprudence"
};
